import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";

import BeachHaven from "./BeachHaven.jsx";
import BigBlue from "./BigBlue.jsx";
import AboutUs from "./components/AboutUs/AboutUs.jsx";
import Contact from "./components/Contact.jsx";
import ErrorPage from "./components/ErrorPage.jsx";
import Gallery from "./Gallery.jsx";
import Home from "./Home.jsx";
import Main from "./Main.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    errorElement: <ErrorPage />,
    children: [
      { path: "", element: <Home /> },
      { path: "about", element: <AboutUs /> },
      { path: "bigblue", element: <BigBlue /> },
      { path: "beachhaven", element: <BeachHaven /> },
      { path: "contact", element: <Contact /> },
      {
        path: "/gallery",
        element: <Gallery />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
